<template>
  <div class="ViewInfo">
    <CenterColumn>

      <h1>
        About The News Machine
      </h1>

      <p>
        The news machine is an educational tool that aims to highlight and give energy to a discussion about information evaluation in everyday life and media consumption. It is intended for, study circles, ordinary lessons or for those who want to learn more about contemporary information evaluation. Playing the game is estimated to take about 15-30 minutes. You can see a live version in Swedish at www.nyhetsmaskinen.se
      </p>

      <p>
        The tool is made by <a href="http://www.fabel.se" target="_blank">Fabel Kommunikation</a> and <a href="https://www.interaktivarum.se" target="_blank">Interaktiva rum</a> in collaboration with the governmental committee <a href="https://demokratiskasamtalet.se/" target="_blank">National focus on media literacy and the democratic dialogue </a> as well as <a href="https://vardemokrati.se/" target="_blank">The committee for the celebration of 100 years of Democracy in Sweden.</a>The english and Turkish version of the game are written by Onur Metin of <a href="https://medarder.org/en/" target="_blank">Medar</a> and has been realized by the <a href="https://www.alda-europe.eu/progetto/team4team/" target="_blank">ALDA project Team4Team</a> 
      </p>

      <p>
        All content is licensed by Creative Commons (<a href="https://creativecommons.org/licenses/by-nc-nd/2.5/se/" target="_blank">CC-BY-NC-ND 2.5</a>) and can be used freely for non-commercial applications as long as the creators are mentioned and no changes are made.
      </p>

      <p>
        If your have questions regarding the game please contact us at <a href="mailto:info@fabel.se">info@fabel.se</a>.
      </p>

      <h2>FAQ</h2>
      <h3>
        How did you make the assessments of whether the news is true or false?
      </h3>
      <p>
        In the game there is an assessment based on the truth of the content. That valuation is an overall assessment based on how well the news has coverage for what is written in the headline and text, whether the focus is on relevant facts and circumstances for events or whether there are other elements that are intended to mislead the reader. However, we understand that this contains gray areas and we want to point out that this is an assessment that we report in the section "Read more about the news" in each section.
      </p>

 



      <h2>Resources</h2>
      <p>
        If you want to learn more about news review and information evaluation, these are good places to check out:
        <ul>
                <li>
                  <a href="https://www.snopes.com/" target="_blank">The fact checking site Snopes</a>
                </li>
                <li>
                  <a href="https://nathatshjalpen.se/a/source-criticism/" target="_blank">Make equal, a step by step guide to information evaluation</a>
                </li>
        </ul>
      </p>

      <ContinueButton @click="home()">Back to the start page</ContinueButton>

    </CenterColumn>

  </div>
</template>

<script>

import CenterColumn from '@/components/CenterColumn.vue'
import ContinueButton from '@/components/ContinueButton.vue'

export default {
  name: 'ViewInfo',
  data: function () {
    return {
    }
  },
  components: {
    CenterColumn,
    ContinueButton
  },
  computed: {
  },
  methods: {
    home(){
      this.$router.push({ name: 'Home'})
    }
  },
  created: function () {
  },
  mounted: function () {
  }
}
</script>
